import useProjectStore from '../components/ProjectCanvas/useProjectStore';
import { filterPropertiesBeforeSave } from './noteUtils';
//this is a constructor for a save event
export function createSaveEvent(type, projectId, viewport, elements, eventData) {
  const positions = useProjectStore.getState().readCanvasIntoComponents(elements);

  // --- DIAG: detect null/missing viewData before it reaches the server ---
  const badPositions = positions.filter(p => !p.viewData || p.viewData.x == null || p.viewData.y == null);
  if (badPositions.length > 0) {
    console.error('[createSaveEvent] NULL viewData detected in positions!', {
      eventType: type,
      projectId,
      badCount: badPositions.length,
      totalCount: positions.length,
      bad: badPositions.map(p => ({ id: p.componentId, type: p.type, viewData: p.viewData })),
    });
    console.trace('[createSaveEvent] stack trace for null viewData');
  }

  let saveEvent = {
    projectId: projectId,
    type: type,
    viewport: viewport,
    positions: positions,
    notePositions: filterPropertiesBeforeSave(useProjectStore.getState().readCanvasIntoNotes(elements)),
    eventData: eventData,
  };

  return saveEvent;
}
